import { Card, CardContent } from '@korint/folio';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { useTranslation } from 'react-i18next';

export function AvailableForProducts({
  productIds,
  children,
}: {
  productIds: ReadonlyArray<string>;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  const { policy } = usePolicyOnDashboard();

  if (!productIds.includes(policy.productId)) {
    return (
      <Card>
        <CardContent className="pt-6 text-sm text-muted-foreground">
          {t('unavailableForProduct')}
        </CardContent>
      </Card>
    );
  }

  return children;
}
